import * as React from 'react';
import Translate from '../../../common/functions/translate';
import MedicineService from '../../../services/medicineService';
import { MedicineModel, ActiveIngredientModel } from "../../../models";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { connect } from 'react-redux';

interface IProps {
  medicineId: any,
  lang: string,
}

interface IState {
  isLoading: boolean;
  medicineId: number;
  error: any;
  currentMedicine: MedicineModel;
}

class overViewTab extends React.Component<IProps, IState> {
  medicineService = new MedicineService();

  constructor(props: IProps) {
    super(props);

    let currentMedicine = new MedicineModel();
    currentMedicine.activeIngredients = new Array<ActiveIngredientModel>(0);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.medicineId,
      currentMedicine: currentMedicine
    };
  }

  componentDidMount() {
    this.getMedicine();
  }

  getMedicine() {
    this.setState({
      isLoading: true
    });

    this.medicineService.getMedicine(this.state.medicineId, this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          currentMedicine: data.data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }


  public render() {

    const { medicineId, isLoading, error, currentMedicine } = this.state;

    let medicineName = currentMedicine.brandName ? currentMedicine.brandName : '';
    let additionalTitle = currentMedicine.additionalTitle ? currentMedicine.additionalTitle : '';

    let medicineNameAndTitle = medicineName + ' ' + additionalTitle;

    let safetyDataElement: any;
    if (currentMedicine.overviewSafetyData || currentMedicine.safetyData) {
      safetyDataElement =
        <div>
          {currentMedicine.overviewSafetyData ? <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewSafetyData }}></div> : null}
          {currentMedicine.safetyData
            ? <div>
              <p style={{ marginBottom: "0px" }}>{currentMedicine.safetyData.storagePrecautions}</p>
              <p style={{ marginBottom: "0px" }}>{currentMedicine.safetyData.shelfLife}</p>
              <p >{currentMedicine.safetyData.productDisposal}</p>
            </div>
            : null
          }
        </div>;
    } else {
      null;
    }

    let adiitinalContentElement: any;
    if (currentMedicine.overviewAdditionalInfo ||
      currentMedicine.manufacturer ||
      currentMedicine.medicineSpecifications ||
      currentMedicine.activeIngredients.length > 0) {
      adiitinalContentElement =
        <div>
          {currentMedicine.overviewAdditionalInfo ? <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewAdditionalInfo }}></div> : null}
          {currentMedicine.activeIngredients.length > 0 ?
            <div style={{ marginBottom: "20px" }}>
              <p style={{ marginBottom: "0px" }}><strong>{Translate('WhatIsInProduct')} {medicineNameAndTitle}</strong></p>
              <p style={{ marginBottom: "0px" }}><strong>{Translate('ActiveIngredients')}: </strong>
                {currentMedicine.activeIngredients.map(m => m.activeIngredientName).join(", ")}
              </p>
              <p style={{ marginBottom: "0px" }}><strong>{Translate('InactiveIngredients')}: </strong>
                {currentMedicine.inactiveIngredients.map(m => m.name).join(", ")}
              </p>
            </div> : null
          }

          {currentMedicine.medicineSpecifications ?
            <div>
              <p style={{ marginBottom: "0px" }}><strong>{Translate('WhatLooksAndPackageContents')} {medicineNameAndTitle}</strong></p>
              <div>
                <p style={{ marginBottom: "0px" }}>
                  {currentMedicine.medicineSpecifications.color ? currentMedicine.medicineSpecifications.color + ', ' : null}
                  {currentMedicine.medicineSpecifications.shape ? currentMedicine.medicineSpecifications.shape + ', ' : null}
                  {currentMedicine.medicineSpecifications.size ? currentMedicine.medicineSpecifications.size + ', ' : null}
                  {currentMedicine.medicineSpecifications.imprint ? Translate('FirstSideImprint') + ' ' + currentMedicine.medicineSpecifications.imprint + '.' : null}
                </p>
                <p style={{ marginBottom: "0px" }}>
                  {currentMedicine.medicineSpecifications.packaging ? currentMedicine.medicineSpecifications.packaging + ', ' : null}
                  {currentMedicine.medicineSpecifications.packageSize ? currentMedicine.medicineSpecifications.packageSize + ', ' : null}
                </p>
                <p>{Translate('NotAllPackagesMarketed')}</p>
              </div>
            </div> : null
          }
          {currentMedicine.authorisationHolder && (currentMedicine.authorisationHolder.name || currentMedicine.authorisationHolder.address) ?
            <div>
              {/* <p style={{ marginBottom: "0px" }}><strong>{Translate('MarketingAuthorisationHolderAndManufacturer')}:</strong></p> */}
              <p style={{ marginBottom: "0px" }}><strong>{Translate('MarketingAuthorisationHolder')}:</strong></p>
              <p>{currentMedicine.authorisationHolder.name}, {currentMedicine.authorisationHolder.address}</p>
            </div> : null}

          {currentMedicine.manufacturer && (currentMedicine.manufacturer.name || currentMedicine.manufacturer.address) ?
            <div>
              <p style={{ marginBottom: "0px" }}><strong>{Translate('Manufacturer')}:</strong></p>
              <p>{currentMedicine.manufacturer.name}, {currentMedicine.manufacturer.address}</p>
            </div> : null}

          {currentMedicine.medicineSpecifications && currentMedicine.medicineSpecifications.lastAuthorizationDate ?
            <div>
              <p><strong>{Translate('LastAuthorizationDate')}: </strong>
                {HelperFunctions.fomatDateAsString(new Date(currentMedicine.medicineSpecifications.lastAuthorizationDate))}
              </p>
            </div>
            : null
          }
        </div>;
    } else {
      null;
    }

    let overViewHeader: any;
    if (currentMedicine.brandName &&
      currentMedicine.activeIngredients.length > 0) {
      overViewHeader =
        <div>
          {/* <p><strong>{Translate('LeafletUserInfo')}</strong></p> */}
          <p style={{ marginBottom: "0px" }}><strong>{medicineNameAndTitle}</strong></p>
          <p><strong >{currentMedicine.activeIngredients.map(m => m.activeIngredientName).join(" / ")}</strong></p>
        </div>;
    } else if (currentMedicine.brandName) {
      overViewHeader = <p style={{ marginBottom: "0px" }}><strong>{medicineNameAndTitle}</strong></p>
    } else {
      null;
    }

    let overViewElement: any;
    let leafletContentElement: any;
    let overViewContent: any;
    if (currentMedicine.overviewAboutMedicine ||
      currentMedicine.overviewBeforeIntake ||
      currentMedicine.overviewDosage ||
      currentMedicine.overviewSideEffects ||
      safetyDataElement ||
      adiitinalContentElement) {
      let i = 0;

      let sectionTitle: any = { id: 0, sectionLabel: "", fullContent: "" };
      let sectionsContentArray: Array<any> = [];

      if (currentMedicine.overviewAboutMedicine) {
        i++;
        sectionTitle = {
          id: i, sectionLabel: Translate('OverviewAbout') + ' ' + medicineNameAndTitle,
          fullContent: <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewAboutMedicine }}></div>
        }
        sectionsContentArray.push(sectionTitle);
      }

      if (currentMedicine.overviewBeforeIntake) {
        i++;
        sectionTitle = {
          id: i, sectionLabel: Translate('OverviewBeforeIntake') + ' ' + medicineNameAndTitle,
          fullContent: <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewBeforeIntake }}></div>
        }
        sectionsContentArray.push(sectionTitle);
      }

      if (currentMedicine.overviewDosage) {
        i++;
        sectionTitle = {
          id: i, sectionLabel: Translate('OverviewDosage') + ' ' + medicineNameAndTitle,
          fullContent: <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewDosage }}></div>
        }
        sectionsContentArray.push(sectionTitle);
      }

      if (currentMedicine.overviewSideEffects) {
        i++;
        sectionTitle = {
          id: i, sectionLabel: Translate('OverviewSideEffects'),
          fullContent: <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewSideEffects }}></div>
        }
        sectionsContentArray.push(sectionTitle);
      }

      if (safetyDataElement) {
        i++;
        sectionTitle = {
          id: i, sectionLabel: Translate('OverviewSafetyData') + ' ' + medicineNameAndTitle,
          fullContent: safetyDataElement
        }
        sectionsContentArray.push(sectionTitle);
      }

      if (adiitinalContentElement) {
        i++;
        sectionTitle = {
          id: i, sectionLabel: Translate('OverviewAdditionalInfo'),
          fullContent: adiitinalContentElement
        }
        sectionsContentArray.push(sectionTitle);
      }

      leafletContentElement =
        <div style={{ marginBottom: "30px" }}>
          <strong>{Translate('WhatIsInLeaflet')}</strong>
          {sectionsContentArray.map(m =>
            <p key={m.id} style={{ marginBottom: "0px" }}> {m.id}. {m.sectionLabel}</p>
          )}
        </div>;

      overViewContent =
        <div>
          {sectionsContentArray.map(m =>
            <div key={m.id} style={{ marginBottom: "30px" }}>
              <p style={{ marginBottom: "0px" }}><strong>{m.id}. {m.sectionLabel}</strong></p>
              {m.fullContent}
            </div>
          )}
        </div>

      overViewElement =
        <div>
          {overViewHeader}
          <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewSummary }}></div>
          {leafletContentElement}
          {overViewContent}
        </div>
    } else {
      overViewElement =
        <div>
          {overViewHeader}
          <div dangerouslySetInnerHTML={{ __html: currentMedicine.overviewSummary }}></div>
        </div>
    }

    return (
      !isLoading ?
        <div>
          {overViewElement}
        </div>
        : null
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(overViewTab);